export default "__VITE_ASSET__9ade635f__"